"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvers = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// definition
var resolvers = {
  Mutation: {
    landingPageAccessToken: function () {
      var _landingPageAccessToken = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_, _ref) {
        var email, res, defaultResponse, _yield$res$json, userId;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                email = _ref.input.email;
                _context.next = 3;
                return fetch('/api/landing-page/access-token', {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  credentials: 'same-origin',
                  body: JSON.stringify({
                    email: email
                  })
                });

              case 3:
                res = _context.sent;
                defaultResponse = {
                  __typename: 'LandingPageAccessTokenResponse',
                  status: 'FAIL',
                  userId: null,
                  message: null
                };

                if (!(res.status !== 200)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  message: "".concat(res.status, " ").concat(res.statusText)
                }));

              case 7:
                _context.next = 9;
                return res.json();

              case 9:
                _yield$res$json = _context.sent;
                userId = _yield$res$json.userId;
                return _context.abrupt("return", _objectSpread(_objectSpread({}, defaultResponse), {}, {
                  status: 'OK',
                  userId: userId
                }));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function landingPageAccessToken(_x, _x2) {
        return _landingPageAccessToken.apply(this, arguments);
      }

      return landingPageAccessToken;
    }()
  }
};
exports.resolvers = resolvers;